import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('@/components/Home.vue')
        },
        {
            path: '/download/:hashid',
            name: 'Download',
            component: () => import('@/components/Download.vue')
        },
        {
            path: '/terms',
            name: 'Terms',
            component: () => import('@/components/Terms.vue')
        }
    ]
})
